<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="28.29" height="13.455" viewBox="0 0 28.29 13.455">
    <g transform="translate(-261.225 -430.274)">
      <path
        d="M281.208,441.564q-.465,0-.929-.025c-1.338-.083-2.571-.243-3.764-.4a39.145,39.145,0,0,0-5.154-.417c-1.057.006-2.124.058-3.133.106a18.7,18.7,0,0,1-4.964-.125c-1.6-.452-2.3-1.9-1.953-4.091a28.261,28.261,0,0,1,2.02-5.249.5.5,0,0,1,.743-.177,6.073,6.073,0,0,1,1.68,1.887c.605.975,2.015.491,2.592.237.7-.3,2.07-1.072,2.443-1.281l1.11-1.55a.5.5,0,0,1,.637-.152c.235.122,5.785,3,6.909,3.649.907.523,3.611,1.585,4.911,2.1l.662.262a11.357,11.357,0,0,0,1.657.433,9.094,9.094,0,0,1,1.557.416c.211.092,1.264.6,1.283,1.487.011.539-.355.995-1.089,1.355A17.773,17.773,0,0,1,281.208,441.564Zm-9.684-1.84a38.591,38.591,0,0,1,5.119.426c1.177.153,2.393.31,3.694.391A16.737,16.737,0,0,0,288,439.122c.421-.206.514-.38.513-.428,0-.139-.3-.422-.685-.592a8.965,8.965,0,0,0-1.363-.354,12.089,12.089,0,0,1-1.822-.483l-.655-.259c-1.423-.56-4.073-1.6-5.044-2.159-.937-.539-5.179-2.75-6.487-3.43l-.922,1.287a.479.479,0,0,1-.16.144c-.072.041-1.775,1.006-2.629,1.381-1.7.748-3.141.507-3.853-.641a5.131,5.131,0,0,0-.949-1.206,27.393,27.393,0,0,0-1.659,4.444c-.25,1.612.166,2.612,1.249,2.917a18.729,18.729,0,0,0,4.644.089c1.022-.049,2.1-.1,3.174-.107Z"
        fill="#777"
      />
      <path
        d="M263.975,443.062a.535.535,0,0,1-.069-.005.5.5,0,0,1-.4-.333l-.841-2.361a.5.5,0,0,1,.872-.49l.107.19.485,1.4.87-1.258a.5.5,0,1,1,.822.568l-1.43,2.07A.5.5,0,0,1,263.975,443.062Z"
        fill="#777"
      />
      <path
        d="M268.3,443.166h0a.5.5,0,0,1-.411-.217l-1.4-2.042a.5.5,0,0,1,.825-.566l.991,1.446,1.229-1.763a.5.5,0,1,1,.82.573l-1.642,2.355A.5.5,0,0,1,268.3,443.166Z"
        fill="#777"
      />
      <path
        d="M277.254,443.141h-.028a.5.5,0,0,1-.415-.267l-1.058-2.017a.5.5,0,0,1,.886-.464l.67,1.278.686-1.011a.5.5,0,1,1,.827.563l-1.155,1.7A.5.5,0,0,1,277.254,443.141Z"
        fill="#777"
      />
      <path
        d="M279.817,443.729c-.328,0-.389-.182-1.208-2.6a.5.5,0,0,1,.948-.32c.134.4.277.814.4,1.177.153-.291.35-.66.6-1.132a.5.5,0,1,1,.882.47c-.492.925-1.045,1.973-1.1,2.092a.414.414,0,0,1-.442.311Z"
        fill="#777"
      />
      <path
        d="M283.415,443.319A.5.5,0,0,1,283,443.1l-1.146-1.679a.5.5,0,0,1,.826-.565l.662.971.551-1.122a.5.5,0,1,1,.9.441l-.928,1.892a.5.5,0,0,1-.413.278Z"
        fill="#777"
      />
      <path
        d="M286.63,442.769a.5.5,0,0,1-.383-.179l-1.381-1.645a.5.5,0,1,1,.766-.642l.779.927.412-1.417a.5.5,0,1,1,.96.279l-.673,2.316a.5.5,0,0,1-.377.35A.514.514,0,0,1,286.63,442.769Z"
        fill="#777"
      />
    </g>
  </svg>
</template>
